import { render, staticRenderFns } from "./UploadNICModal.vue?vue&type=template&id=f6d8e0ca&scoped=true&"
import script from "./UploadNICModal.vue?vue&type=script&lang=js&"
export * from "./UploadNICModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadNICModal.vue?vue&type=style&index=0&id=f6d8e0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d8e0ca",
  null
  
)

export default component.exports